import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "apCheckbox" }
const _hoisted_2 = ["checked"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      type: "checkbox",
      class: "apCheckbox__input",
      checked: _ctx.checked,
      onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.input && _ctx.input(...args)))
    }, null, 40, _hoisted_2),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "apCheckbox__box" }, null, -1))
  ]))
}